import * as ActionTypes from "./ActionTypes";

/**
 * Stripe Connect payout-onboarding status ({payouts_enabled, charges_enabled,
 * details_submitted}). Held in Redux so the onboarding screen and the charge
 * gate can read it; the charge path re-fetches fresh rather than trusting a
 * cached value (the server is the real authority).
 */
export const setStripeConnectStatus = (data) => ({
  type: ActionTypes.SET_STRIPE_CONNECT_STATUS,
  data,
});
